module.exports = __webpack_public_path__ + "img/logo-eecs.7fc4ffaf.webp";